import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { useQuery } from "react-query";
import { getStatsFigures } from "../../../services/partnerApi";

const FiguresChart = () => {
  const { data, isLoading, isSuccess } = useQuery("figures", () => {
    return getStatsFigures();
  });

  console.log(data);

  return (
    <SimpleGrid columns={2} spacing={2}>
      <Box>
        <Box p="3">
          <Text fontSize="xx-large">
            {isLoading && "--"}
            {!isLoading && isSuccess && data.data.totalReaders}
          </Text>
          <Text color="gray.400" fontSize="xs">
            Active readers
            <br />
            this week
          </Text>
        </Box>
      </Box>
      <Box>
        <Box p="3">
          <Text fontSize="xx-large">
            {isLoading && "--"}
            {!isLoading && isSuccess && data.data.totalReaders}
          </Text>
          <Text color="gray.400" fontSize="xs">
            Total readers
          </Text>
        </Box>
      </Box>
    </SimpleGrid>
  );
};

export default FiguresChart;
